import ModalDialog from 'components/ui/modal-dialog'
import ProgressBar from 'components/ui/progress-bar'
import { UbsLogo } from 'features/onboarding/assets/ubs-logo'
import {
  ONBOARDING_STEPS,
  OnboardingStepKeys,
} from 'features/onboarding/config/steps'

import { useOnboarding } from '../../hooks/use-onboarding'
import { Step1, Step2, Step3, Step4, Step5, Step6, Step7 } from '../steps'

interface OnboardingModalProps {
  isOpen: boolean
  onClose: () => void
}

export default function OnboardingModal({
  isOpen,
  onClose,
}: OnboardingModalProps) {
  const { state, nextStep, previousStep } = useOnboarding()

  const calculateProgress = () => {
    const totalSteps = Object.keys(ONBOARDING_STEPS).length
    return Math.round(((state.currentStep - 1) / (totalSteps - 1)) * 100)
  }

  const getCurrentStep = () => {
    const stepKey = `step${state.currentStep}` as OnboardingStepKeys
    return ONBOARDING_STEPS[stepKey]
  }

  const renderCurrentStep = () => {
    const currentStepConfig = getCurrentStep()

    switch (currentStepConfig?.id) {
      case 'step1':
        return <Step1 onNext={nextStep} />
      case 'step2':
        return <Step2 onNext={nextStep} />
      case 'step3':
        return <Step3 onNext={nextStep} onPrevious={previousStep} />
      case 'step4':
        return <Step4 onNext={nextStep} onPrevious={previousStep} />
      case 'step5':
        return <Step5 onNext={nextStep} onPrevious={previousStep} />
      case 'step6':
        return <Step6 onNext={nextStep} onPrevious={previousStep} />
      case 'step7':
        return <Step7 onClose={onClose} />
      default:
        return null
    }
  }

  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      variant="full"
      closeButton
      content={
        <div className="tw-pt-6">
          <div className="tw-mx-auto tw-flex tw-max-w-[640px] tw-flex-col tw-items-center tw-justify-center tw-gap-8">
            <UbsLogo />
            <ProgressBar progress={calculateProgress()} />
          </div>

          {renderCurrentStep()}
        </div>
      }
      zIndex="tw-z-[99999]"
    />
  )
}
